import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { I18nModule, DidNotVisitFormGuard, DidNotVisitVideoidentificationGuard, HasAnswersGuard } from '@app/core';
import { QuestionnaireEffects } from './store/questionnaire.effects';
import { QUESTIONNAIRE_REDUCER } from './store/questionnaire.reducer';
import { FEATURE_STORE_NAME } from './store/questionnaire.state';
import { SharedModule } from 'src/app/shared/shared.module';
import { HasQuestionsGuard } from './guards/has-questions.guard';
import { IsCitizenGuard } from './guards/is-citizen.guard';
import { ProvinceInV2Guard } from './guards/province-in-v2.guard';
import { QuestionnaireComponent } from './components/questionnaire.component';
import { QuestionnaireService } from './services/questionnaire.service';
import { QuestionnaireRoutingModule } from './questionnaire-routing.module';

@NgModule({
	declarations: [QuestionnaireComponent],
	imports: [
		CommonModule,
		QuestionnaireRoutingModule,
		SharedModule,
		I18nModule.forFeature('questionnaire'),
		EffectsModule.forFeature([QuestionnaireEffects]),
		StoreModule.forFeature(FEATURE_STORE_NAME, QUESTIONNAIRE_REDUCER),
	],
	exports: [QuestionnaireComponent],
	providers: [
		QuestionnaireService,
		HasQuestionsGuard, 
		HasAnswersGuard, 
		IsCitizenGuard, 
		DidNotVisitFormGuard, 
		DidNotVisitVideoidentificationGuard, 
		ProvinceInV2Guard],
})
export class QuestionnaireHomeModule {}
